// Product grid/list
function listgridJavascript(root = document) {
  root.querySelectorAll('.wblistgridbtn').forEach((link) => {
    if (link.dataset.gridToggleReady === 'true') return;
    link.dataset.gridToggleReady = 'true';

    link.addEventListener('click', function () {
      const productGrid = document.getElementById('product-grid');
      if (!productGrid) return;

      document.querySelectorAll('.wblistgridbtn').forEach((item) => item.classList.remove('active'));
      this.classList.add('active');

      const listView = this.classList.contains('listv');
      productGrid.classList.toggle('product-list', listView);
      productGrid.classList.toggle('product-grid', !listView);
    });
  });
}

// Play autoplay videos only while they are visible.
const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const videoObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && !reduceMotionQuery.matches) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    )
  : null;

function initializeAutoplayVideos(root = document) {
  root.querySelectorAll('video[autoplay]').forEach((video) => {
    if (video.dataset.visibilityPlaybackReady === 'true') return;
    video.dataset.visibilityPlaybackReady = 'true';

    if (reduceMotionQuery.matches) video.pause();
    if (videoObserver) videoObserver.observe(video);
  });
}

function setCountdownValue(countdown, selector, value) {
  const element = countdown.querySelector(selector);
  if (element) element.textContent = String(value).padStart(2, '0');
}

function updateCountdowns() {
  document.querySelectorAll('.countd_all').forEach((countdown) => {
    const dateValue = countdown.getAttribute('data-date');
    const targetTime = dateValue ? new Date(dateValue).getTime() : NaN;
    const distance = targetTime - Date.now();

    if (!dateValue) {
      setCountdownValue(countdown, '.main_cdays .wb_cdays', 0);
      setCountdownValue(countdown, '.main_chours .wb_chours', 0);
      setCountdownValue(countdown, '.main_cminutes .wb_cminutes', 0);
      setCountdownValue(countdown, '.main_cseconds .wb_cseconds', 0);
      return;
    }

    if (!Number.isFinite(targetTime) || distance < 0) {
      countdown.hidden = true;
      const container = countdown.parentElement;
      const message = container?.querySelector('.countdownMessage, #countdownMessage');
      if (message) message.style.display = 'block';
      return;
    }

    countdown.hidden = false;
    setCountdownValue(countdown, '.main_cdays .wb_cdays', Math.floor(distance / 86400000));
    setCountdownValue(countdown, '.main_chours .wb_chours', Math.floor((distance % 86400000) / 3600000));
    setCountdownValue(countdown, '.main_cminutes .wb_cminutes', Math.floor((distance % 3600000) / 60000));
    setCountdownValue(countdown, '.main_cseconds .wb_cseconds', Math.floor((distance % 60000) / 1000));
  });
}

let countdownTimer;
function initializeCountdowns() {
  const hasCountdowns = document.querySelector('.countd_all');
  if (!hasCountdowns) {
    if (countdownTimer) window.clearInterval(countdownTimer);
    countdownTimer = undefined;
    return;
  }

  updateCountdowns();
  if (!countdownTimer) countdownTimer = window.setInterval(updateCountdowns, 1000);
}

function initializeCustomFeatures(root = document) {
  listgridJavascript(root);
  initializeAutoplayVideos(root);
  initializeCountdowns();
}

document.addEventListener('shopify:section:load', (event) => initializeCustomFeatures(event.target));
initializeCustomFeatures();
